export default "<div><ng-content></ng-content></div>\n"